export enum TaskTypes {
  DirectSeeding = "direct_seeding",
  IndoorSeeding = "indoor_seeding",
  BedPreparation = "bed_preparation",
  Transplanting = "transplanting",
  Cultivating = "cultivating",
  Harvesting = "harvesting",
  Custom = "custom"
}

export type TaskType = `${TaskTypes}`;

export type TaskTypesWithNoneType = (TaskType | "none")[];

// Labels the backend derives from the workflow rather than stored task types — see
// `CropWorkflowTask#default_title_key`.
export enum DerivedTaskTitleKeys {
  FirstHarvesting = "first_harvesting",
  PerennialHarvesting = "perennial_harvesting"
}

export type TaskTitleKey = TaskType | `${DerivedTaskTitleKeys}`;

export type TaskNamePair = { key: TaskTitleKey; name: string };

// Partial: the payload is whatever the backend served, so a name can be absent.
export type TaskNames = Partial<Record<TaskTitleKey, string>>;
